import React from 'react'
import { Icon, Row, Col } from 'antd';


export const Results = (props) => {
    return (
        <Row type='flex' justify='center'>
            <Col xs={24} sm={24} md={20} lg={18} xl={12} className='frosted-card'>
                <h4 style={{ display: 'inline-block !important' }}>Drug: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.group === 'tpa' ? 'Alteplase tPA (0.9 mg/kg body weight, max dose 90 mg)' : 'Tenecteplase tNK (0.25 mg/kg body weight, max dose 25 mg)'}</h2></h4>
                {props.tnkDose ?
                    <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Dose: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.tnkDose}</h2></h4>
                    :
                    <div>
                        <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Bolus Dose: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.tpaBolusDose}</h2></h4>
                        <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Infusion Dose: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.tpaInfusionDose}</h2></h4>
                    </div>
                }
                <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Study ID: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.studyID}</h2></h4>
                <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Weight: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.weight} kg</h2></h4>
                <h4 style={{ marginTop: '2rem', display: 'inline-block !important' }}>Date and Time: <h2 style={{ color: '#4CDEF5', display: 'inline-block' }}>{props.date}</h2></h4>
                <p style={{ marginTop: '2rem', display: 'inline-block !important', fontSize: '18px', textAlign: 'center' }}>
                  Please remember to note the lot number and expiry date of the drug used!"
                </p>
                <h5 className='btn-custom' style={{ marginTop: '5rem' }} onClick={props.onBackClick}><Icon type="arrow-left" style={{ marginRight: '0.5rem' }} />Back</h5>
            </Col>
        </Row>
    )
}



// WEBPACK FOOTER //
// ./src/components/Results/Results.js